var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93806 0H4.06907C1.51977 0 0 1.51977 0 4.06907V9.93106C0 12.4874 1.51977 14.0071 4.06907 14.0071H9.93106C12.4804 14.0071 14.0001 12.4874 14.0001 9.93806V4.06907C14.0071 1.51977 12.4874 0 9.93806 0Z",
    fill: "#C6E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4384 6.35559H7.64457V3.56173C7.64457 3.20927 7.35229 2.91699 6.99984 2.91699C6.64738 2.91699 6.3551 3.20927 6.3551 3.56173V6.35559H3.56124C3.20878 6.35559 2.9165 6.64787 2.9165 7.00033C2.9165 7.35278 3.20878 7.64506 3.56124 7.64506H6.3551V10.4389C6.3551 10.7914 6.64738 11.0837 6.99984 11.0837C7.35229 11.0837 7.64457 10.7914 7.64457 10.4389V7.64506H10.4384C10.7909 7.64506 11.0832 7.35278 11.0832 7.00033C11.0832 6.64787 10.7909 6.35559 10.4384 6.35559Z",
    fill: "#3694FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.7e7770d23e38183bb05aed5ff31c3acc.svg";
export { ForwardRef as ReactComponent };